var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondFisicaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 31,
    viewBox: "0 0 20 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05984 21.4621V29.0924C9.05984 30.1474 8.20739 31 7.15247 31C6.09756 31 5.2451 30.1474 5.2451 29.0924V15.7909L3.54019 18.6291C2.99852 19.5296 1.82284 19.8209 0.922436 19.2792C0.0220286 18.7375 -0.269227 17.5617 0.272438 16.6612L3.74797 10.878C4.78513 9.15517 6.64455 8.10014 8.65315 8.10014H10.4238C12.4324 8.10014 14.2918 9.15517 15.3289 10.878L18.8045 16.6612C19.3461 17.5617 19.0549 18.7357 18.1545 19.2792C17.2541 19.8209 16.0802 19.5296 15.5367 18.6291L13.8265 15.7909V29.0924C13.8265 30.1474 12.974 31 11.9191 31C10.8642 31 10.0118 30.1474 10.0118 29.0924V21.4172H9.05807L9.05984 21.4621ZM6.67652 2.86137C6.67652 1.83831 7.22173 0.893402 8.10793 0.383648C8.99413 -0.127883 10.0846 -0.127883 10.969 0.383648C11.8552 0.895178 12.4004 1.84009 12.4004 2.86137C12.4004 3.88266 11.8552 4.82934 10.969 5.3391C10.0846 5.85063 8.99236 5.85063 8.10793 5.3391C7.22173 4.82757 6.67652 3.88266 6.67652 2.86137Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondFisicaIcon);
export default __webpack_public_path__ + "static/media/cond_fisica_icon.b7e2ce132376dae9f443e498372231b8.svg";
export { ForwardRef as ReactComponent };